export default "__VITE_ASSET__CX1l3EYj__"